var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"map","space":"0"}},[_c('iframe',{staticStyle:{"border":"0","display":"block"},attrs:{"allowfullscreen":"","aria-hidden":"false","frameborder":"0","height":"500","src":"https://maps.google.com/maps?q=jmd%20megapolis&t=&z=11&ie=UTF8&iwloc=&output=embed","tabindex":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }